export function scrollToSectionById(
  id: string,
  behavior: ScrollBehavior = 'smooth'
) {
  const el = document.getElementById(id);
  if (!el) return false;

  el.scrollIntoView({ block: 'start', inline: 'nearest', behavior });
  return true;
}

export function getSectionIdFromHref(href?: string): string | null {
  if (!href?.includes('section=')) return null;

  try {
    const url = new URL(href, window.location.origin);
    return url.searchParams.get('section');
  } catch {
    return null;
  }
}

export function handleSectionHrefClick(
  href: string | undefined,
  event: { preventDefault: () => void }
): boolean {
  const sectionId = getSectionIdFromHref(href);
  if (!sectionId) return false;

  try {
    const url = new URL(href!, window.location.origin);
    if (url.pathname !== window.location.pathname) return false;
  } catch {
    return false;
  }

  event.preventDefault();
  scrollToSectionById(sectionId);
  return true;
}
